import S3MX0A from './S3MX-0A.js';
import S3XT0S from './S3XT-0S.js';
export const xmod = { 'S3MX-0A': S3MX0A, 'S3XT-0S': S3XT0S };
